import { InteriorObject } from "./interior-object.model";
import { IFloor } from './interfaces/iFloor.interface';

export class Floor implements IFloor {
    floorType: number;
    elements: InteriorObject[] = [];
    isFloorImageVisible: boolean;
    floorImageBase64Data: string;
    floorImageOpacity: number;
}
